import type { WistiaOembedResponse } from '../types';

/**
 * Fetches video metadata from Wistia's oembed API
 * @param videoId - The Wistia video ID
 * @returns Promise with video metadata
 */
export async function fetchVideoMetadata(videoId: string): Promise<WistiaOembedResponse> {
  const baseUrl = 'https://fast.wistia.com/oembed/?url=';
  const accountUrl = encodeURIComponent('https://home.wistia.com/medias/');
  const url = `${baseUrl}${accountUrl}${videoId}&format=json&width=426`;

  const response = await fetch(url);

  if (!response.ok) {
    throw new Error(`Failed to fetch video metadata for ${videoId}: ${response.statusText}`);
  }

  return response.json();
}
